import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import { useFormik } from "formik";
import { Box, Heading, Text } from "@chakra-ui/react";
import { createFormSubmission } from "../../api/shortcodeTemplateApi";
import { sendDataToWebhooks } from "../../api/webhookApi";
import FormFields from "./Fields";
import { FormValidationSchema } from "./utils";
import Alertment from "./alert";
const FormPreview = ({ template, displayTitle, displayDesc, apiConfig }) => {
  const {
    fields: formFields,
    title,
    description,
    submissionConfig: formSubmissionConfig,
    submitBtnConfig: submitConfig,
  } = template.form;
  const standardFields = {
    textField: [],
    url: [],
    paragraph: [],
    number: [],
    dropDown: [],
    checkBox: [],
    rating: [],
  };
  formFields.map((field) => {
    standardFields[field.type] && standardFields[field.type].push(field);
  });
  const {
    messageBody: confirmationMessage,
    configType: formSubmissionType,
    redirectExternalPage,
    redirectWordpressPage,
  } = formSubmissionConfig;
  const [shouldRedirect, setRedirect] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const { formValidationSchema } = new FormValidationSchema(formFields);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      address: {
        addressLine1: "",
        addressLine2: "",
        state: "",
        city: "",
        country: "",
        zipCode: "",
      },
      textField: [],
      url: [],
      paragraph: [],
      number: [],
      dropDown: [],
      checkBox: [],
      rating: [],
    },
    validationSchema: formValidationSchema,
    onSubmit: (values) => {
      console.log("values submit", values);
      const submissionBody = {};
      const webhookRequestBody = {
        form: {},
        webhooks: template.integration.webhooks,
      };
      Object.keys(values).forEach((key) => {
        const value = values[key];
        if (value) {
          submissionBody[key] = value;
          webhookRequestBody.form[key] = value;
        }
      });
      submissionBody.formId = template.id;
      submissionBody.id = uuidv4();

      createFormSubmission(submissionBody, apiConfig)
        .then((response) => {
          if (webhookRequestBody.webhooks.length) {
            sendDataToWebhooks(webhookRequestBody, apiConfig).then(
              (response) => {
                switch (formSubmissionType) {
                  case "CONFIRMATION_MESSAGE": {
                    setSubmitted(true);
                    return;
                  }
                  case "REDIRECT_EXTERNAL_PAGE":
                    return setRedirect(true);
                  case "REDIRECT_WORDPRESS_PAGE":
                    return setRedirect(true);
                }
              }
            );
          } else {
            switch (formSubmissionType) {
              case "CONFIRMATION_MESSAGE": {
                setSubmitted(true);
                return;
              }
              case "REDIRECT_EXTERNAL_PAGE":
                return setRedirect(true);
              case "REDIRECT_WORDPRESS_PAGE":
                return setRedirect(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });
  useEffect(() => {
    if (shouldRedirect && formSubmissionType == "REDIRECT_EXTERNAL_PAGE") {
      window.open(redirectExternalPage, "_blank");
    }
    if (shouldRedirect && formSubmissionType == "REDIRECT_WORDPRESS_PAGE") {
      window.open(redirectWordpressPage, "_blank");
    }
  }, [shouldRedirect]);
  return (
    <Box bg="background.secondary" m="0 auto" p="2rem" w="100%" boxShadow="lg">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit(e);
        }}
      >
        {displayTitle == "1" ? (
          <>
            {" "}
            <Heading mb="2" as="h5" size="md">
              {title}
            </Heading>
            {displayDesc == "1" ? <Text mb="3">{description}</Text> : null}
          </>
        ) : null}
        <FormFields
          fields={formFields}
          standardFields={standardFields}
          formik={formik}
          submitConfig={submitConfig}
        />
        {submitted ? <Alertment message={confirmationMessage} /> : null}
      </form>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    formFields: state.form.dropped,
    title: state.form.title,
    description: state.form.description,
    submitConfig: state.form.submitConfig,
    formSubmissionConfig: state.formConfig,
  };
};

export default connect(mapStateToProps)(FormPreview);
